import axios, { type AxiosRequestConfig } from 'axios';

import { POLICY_FILES } from '@/constants';
import { convertPolicyHtml } from '@/utils';

export const uploadToS3FromPresignedURL = ({
  url = '',
  data,
  onUploadProgress,
}: AxiosRequestConfig) => {
  return axios
    .post(url, data, {
      onUploadProgress: (res) => {
        if (res?.upload) {
          onUploadProgress?.(res);
        }
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      /* eslint-disable-next-line no-console */
      console.error(err);
    });
};

export const getPolicyFromS3 = (key: keyof typeof POLICY_FILES) => {
  return axios
    .get(`${process.env.REACT_APP_POLICY_S3_DOMAIN}/${POLICY_FILES[key]}`)
    .then((res) => convertPolicyHtml(res.data));
};
